<template>
  <v-dialog v-model="showDialog" :width="width" scrollable @click:outside="onClickOutside">
    <v-card color="surface lighten-1">
      <v-card-title>
        {{ title }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="custom-scrollbar intro-dialog surface">
        <slot></slot>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <slot name="actions"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'EcsUserIntroductionDialog',
  props: {
    title: {
      type: String,
      required: true
    },
    showDialog: {
      type: Boolean,
      required: true
    },
    width: {
      type: String,
      default: '500'
    }
  },
  methods: {
    onClickOutside() {
      this.$emit('clickOutside');
    }
  }
};
</script>

<style>
.intro-dialog {
  max-height: 80vh;
  overflow-y: auto;
}
</style>
